<main
  class="flex w-full flex-col items-center justify-center rounded-2xl bg-white p-6 py-12 text-center">
  <p class="text-lg font-heavy leading-md text-brand-600">403 Error</p>
  <h1 class="my-[6px] text-3xl font-heavy leading-5xl text-gray-900">Access Denied</h1>
  <p class="text-base font-book leading-xl text-gray-600">
    Sorry, you don't have permission to access this page. Please contact your administrator if you
    believe this is an error.
  </p>

  <div class="mt-[32px] flex w-full justify-center gap-4">
    <ui-button
      (click)="back()"
      appearance="stroked"
      color="secondary"
      label="Go Back">
    </ui-button>
    <ui-button
      [routerLink]="['/private/landing']"
      color="secondary"
      label="Take Me Home">
    </ui-button>
  </div>
</main>
